export default __webpack_public_path__ + "static/media/cu.b6406c65.svg";